import React from 'react'

import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'

import DndListItem, { DndListItemProps } from '../DndListItem'

interface DndSortableListItemProps extends DndListItemProps {
  id: string
}

const DndSortableListItem = (props: DndSortableListItemProps) => {
  const {
    children,
    disabled,
    editable,
    handleDelete,
    id,
    sx,
    variant,
    ...rest
  } = props

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      disabled: disabled,
      id: id
    })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  }

  return (
    <DndListItem
      editable={editable}
      disabled={disabled}
      handleDelete={handleDelete}
      listeners={listeners}
      ref={setNodeRef}
      style={style}
      sx={sx}
      variant={variant}
      {...attributes}
      {...rest}
    >
      {children}
    </DndListItem>
  )
}

DndSortableListItem.displayName = 'DndSortableListItem'
export default DndSortableListItem
